import {Component, HostListener, OnDestroy} from '@angular/core'
import {PageComponent, PageMetadata} from '../../../core/seo/page-metadata'
import {OptableLayout} from '../../../core/components/layout/optable-layout.interface'
import {ActivatedRoute, Router} from '@angular/router'
import {Observable, Subject} from 'rxjs'
import {map, takeUntil} from 'rxjs/operators'
import {LinkService} from '../../../core/i18n/link.service'
import {SendMessageEvent} from '../../../craft/contact-form-card/contact-form-card.types'
import {IndustryOverviewPage_CreateLeadGql} from '../../../../__generated__/types'
import {IndustryOverviewPageResolved} from './industry-overview-page.resolver'
import {PUBLIC_ROUTES} from '../../../shared/routing/public.routes'
import {Language} from '../../../core/i18n/language'

@Component({
  selector: 'bgo-industry-overview-page',
  templateUrl: './industry-overview-page.component.html',
  standalone: false,
})
export class IndustryOverviewPageComponent extends PageComponent implements OptableLayout, OnDestroy {
  readonly page$: Observable<IndustryOverviewPageResolved>
  readonly optOutOfLayout = true
  readonly privacyLink = this.linkService.localizedPathTo(PUBLIC_ROUTES.DATA_PRIVACY)

  showStickyFooter = false
  private readonly unsubscribe$ = new Subject<void>()

  constructor(
    private readonly route: ActivatedRoute,
    readonly linkService: LinkService,
    private readonly router: Router,
    private readonly createLeadGql: IndustryOverviewPage_CreateLeadGql,
  ) {
    super()
    this.page$ = this.route.data.pipe(map(data => data['content']))
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event) {
    this.showStickyFooter = event.target?.defaultView?.scrollY > 400
  }

  ngOnDestroy() {
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }

  getPageMetadata(): Observable<PageMetadata> {
    return this.page$.pipe(
      map(page => ({
        title: page.title,
        description: page.description,
        doNotIndexPage: page.doNotIndexPage,
        canonicalUrl: page.canonicalUrl,
      })),
    )
  }

  getPageAvailableLanguages(): Observable<Language[] | undefined> {
    return this.page$.pipe(map(p => p.availableLanguages))
  }

  clientMessageSent(e: SendMessageEvent): void {
    this.createLeadGql
      .mutate({
        req: {
          ...e.fields,
          referrer: this.router.url,
        },
      })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(r => {
        if (r.data?.createLead.success) {
          e.done()
        }
      })
  }
}
